import { UserPlan } from "@/components/utils/getUserPlan";

export interface PaymentBlockChainData {
  tokenSymbol: string;
  tokenAddress: string;
  chainId: number;
  depositAddress: string;
}

interface PricingInfo {
  basePrice: number;
  subtotal: number;
  discountPercent: number;
  discountAmount: number;
  totalAmount: number;
  proratedCredit: number;
  actualAmountToPay: number;
}

export interface UpgradePlanInfo {
  planId: string;
  periodId: string;
  changeType: string;
  previousPlanId: string;
  pricing: PricingInfo;
  proratedDetails: {
    creditAmount: number;
    remainingDays: number;
    dailyRate: number;
  };
  currentSubscription: {
    planId: string;
    endDate: string;
    remainingDays: number;
  };
  newSubscription: {
    startDate: string;
    endDate: string;
    durationMonths: number;
  };
  requiresPayment: false;
  requiresConfirmation: true;
  calculatedAt: string;
  orderId: string;
  proratedCredit: number;
  nextPaymentDate: Date | string;
  nextPaymentAmount: number;
  paymentMethod: string;
}

export interface Month {
  title: string;
  discount: number;
  fontSize: string;
  background: string;
  monthNo: number;
  description: string;
  periodId: string;
}

export interface SubscriptionOrder {
  createdAt: Date;
  changeType: string;
  uid: string;
  amount: number | string;
  durationMonths: number;
  periodId: string;
  planId: UserPlan;
  status: string;
  id: string;
  expiresAt: Date;
  endDate: Date;
  isUpgradePlan: boolean;
  orderId: string;
  confirmedAt: string | null | Date | number;
  expiredAt: string | null | Date | number;
  cancelledAt: string | null | Date | number;
  paymentData: PaymentBlockChainData;
  paymentMethod: string;
  pricing: PricingInfo;
  attributionRecommendationId?: string | null;
}

export interface Network {
  name: string;
  image: string;
}

export interface SubscriptionMember {
  chainId: number;
  durationMonths: number;
  endDate: Date;
  isActive: boolean;
  orderId: string;
  paymentMethod: string;
  periodId: string;
  planId: UserPlan;
  startDate: Date;
  uid: string;
  updatedAt: Date;
}

export interface TransferInfo {
  chainId: number;
  token: string;
  tokenAddress: string;
  amount: number;
  depositAddress: string;
}

export enum PLAN_STEPS {
  "loading" = 0,
  "choosePlan" = 1,
  "payment" = 2,
  "paymentSuccess" = 3,
  "confirmPending" = 4,
  "confirmUpgrade" = 5,
  "confirmChoosePaymentMethod" = 6
}

export type PlanStepType =
  | PLAN_STEPS.choosePlan
  | PLAN_STEPS.payment
  | PLAN_STEPS.paymentSuccess;

export interface PaymentMethod {
  img: string;
  description: string;
  enable?: boolean;
  hasBadge?: boolean;
}

export interface NewPlanObject {
  plan: UserPlan | string | undefined;
  periodId: string;
  currentPaymentMethod: string;
}

export interface PaidyConfig {
  api_key: string;
  logo_url?: string;
  closed?: (callbackData: unknown) => void;
}

export interface PaidyHandler {
  launch: (payload: PaidyPayload) => void;
}

export interface PaidyPayload {
  amount: number;
  currency: string;
  store_name: string;
  order: {
    items: Array<{
      id: string;
      quantity: number;
      title: string;
      unit_price: number;
      description: string;
    }>;
    order_ref: string;
  };
  description: string;
}
